module.exports = __webpack_public_path__ + "img/BecomeIns-1.442557b4.svg";